/* SanitairLuxe — Fotogalerij & telefoonversie productpagina's
   1. Pijlen links/rechts op de grote foto (luxe- en set-pagina's)
   2. Thumbnail aantikken = paarse rand (+ foto wisselen op telefoon)
   3. Telefoon: altijd zichtbare, rechthoekige schuifbalk onder de thumbnails
   4. Telefoon: lange productlijsten eerste 4 + "Bekijk alle producten (x)"
   5. Knop "Bekijk kleuren / inhoud van deze set": netjes scrollen
   6. "In winkelwagen": na klikken kort oranje, daarna terug naar groen */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var LIMIT = 4;
  var CHEVRON = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- 6. In winkelwagen: oranje flits na klikken ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.single_add_to_cart_button, .slx-atc-btn, .sticky-atc-bar__button');
    if (!btn || btn.disabled) return;
    btn.classList.add('sl-atc-flash');
    clearTimeout(btn._slFlash);
    btn._slFlash = setTimeout(function () {
      btn.classList.remove('sl-atc-flash');
      if (document.activeElement === btn) btn.blur();
    }, 800);
  }, true);

  /* ---------- 5. Scrollen naar "Inhoud van deze set" ---------- */
  function stickyHeaderHeight() {
    var max = 0;
    var candidates = document.querySelectorAll('#shopify-section-header, .header-section, header, .header, [id*="header"]');
    candidates.forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > max && r.bottom < window.innerHeight / 2) max = r.bottom;
      }
    });
    return max;
  }

  function scrollToSet() {
    var target = document.querySelector('.slcsb .slcsb__container') || document.querySelector('.slcsb');
    if (!target) return false;
    var offset = stickyHeaderHeight() + (mq.matches ? 16 : 28);
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-slx-set-jump], .slx-set-jump-btn');
    if (!btn) return;
    if (scrollToSet()) {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(function () { btn.blur(); }, 50);
    }
  }, true);

  /* ---------- Schuifbalk ---------- */
  function addBar(scroller, afterEl) {
    if (!scroller || scroller.dataset.slBar) return;
    scroller.dataset.slBar = '1';
    var bar = document.createElement('div');
    bar.className = 'sl-mgal-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.style.order = '99';
    var thumb = document.createElement('span');
    thumb.className = 'sl-mgal-bar__thumb';
    bar.appendChild(thumb);
    (afterEl || scroller).insertAdjacentElement('afterend', bar);

    function update() {
      var sw = scroller.scrollWidth;
      var cw = scroller.clientWidth;
      if (!cw || sw <= cw + 2) {
        thumb.style.width = '100%';
        thumb.style.left = '0%';
        return;
      }
      var w = Math.max((cw / sw) * 100, 12);
      var max = sw - cw;
      thumb.style.width = w + '%';
      thumb.style.left = (max > 0 ? (scroller.scrollLeft / max) * (100 - w) : 0) + '%';
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    scroller._slBarUpdate = update;
    setTimeout(update, 400);
    update();
  }

  /* ---------- Pijlen luxe/set-pagina's ---------- */
  function addLuxeArrows() {
    document.querySelectorAll('.slx-gallery').forEach(function (g) {
      var main = g.querySelector('.slx-gallery__main');
      if (!main || main.dataset.slArrows) return;
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.slx-gallery__thumb'));
      if (thumbs.length < 2) return;
      main.dataset.slArrows = '1';
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sl-gal-arrow sl-gal-arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? (DE ? 'Vorheriges Bild' : 'Vorige foto') : (DE ? 'N\u00e4chstes Bild' : 'Volgende foto'));
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          if (i < 0) i = 0;
          var n = (i + (dir === 'next' ? 1 : -1) + thumbs.length) % thumbs.length;
          thumbs[n].click();
          var vp = g.querySelector('.slx-gallery__thumbs-viewport');
          if (vp) {
            var t = thumbs[n];
            var left = t.offsetLeft - (vp.clientWidth - t.offsetWidth) / 2;
            vp.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        });
        b.addEventListener('mousemove', function (e) { e.stopPropagation(); });
        main.appendChild(b);
      });
    });
  }

  /* ---------- Standaard productpagina: thumbnails ---------- */
  function bindThemeThumbs() {
    var thumbs = document.getElementById('Product-Thumbnails');
    var slider = document.getElementById('Product-Slider');
    if (!thumbs || !slider || thumbs.dataset.slBound) return;
    thumbs.dataset.slBound = '1';
    var first = thumbs.querySelector('.product-thumbnail.is-initial-selected') || thumbs.querySelector('.product-thumbnail');
    if (first) first.classList.add('sl-thumb-active');
    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.product-thumbnail');
      if (!t) return;
      thumbs.querySelectorAll('.product-thumbnail').forEach(function (el) { el.classList.remove('sl-thumb-active'); });
      t.classList.add('sl-thumb-active');
    });
  }

  /* ---------- Productlijsten inklappen (telefoon) ---------- */
  function collapse(list, items) {
    if (!list || list.dataset.slCollapse) return;
    if (!items || items.length <= LIMIT) return;
    list.dataset.slCollapse = '1';
    var hidden = items.slice(LIMIT);
    hidden.forEach(function (el) { el.classList.add('sl-m-collapsed'); });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sl-m-showall';
    btn.innerHTML = '<span>' + (DE ? 'Alle Produkte anzeigen' : 'Bekijk alle producten') + ' (' + hidden.length + ')</span>' + CHEVRON;
    btn.addEventListener('click', function () {
      hidden.forEach(function (el) { el.classList.remove('sl-m-collapsed'); });
      btn.parentNode && btn.parentNode.removeChild(btn);
    });
    list.insertAdjacentElement('afterend', btn);
  }

  function init() {
    addLuxeArrows();
    bindThemeThumbs();

    if (!mq.matches) return;

    document.querySelectorAll('.slx-gallery__thumbs-viewport').forEach(function (el) { addBar(el); });
    document.querySelectorAll('#slCompleteBathroom .sl-room__thumbs').forEach(function (el) { addBar(el); });

    document.querySelectorAll('#slCompleteBathroom .sl-package').forEach(function (pkg) {
      var items = Array.prototype.filter.call(pkg.children, function (el) {
        return el.matches && el.matches('article.sl-line');
      });
      collapse(pkg, items);
    });

    document.querySelectorAll('.slcsb__list').forEach(function (list) {
      var items = Array.prototype.filter.call(list.children, function (el) {
        return el.matches && el.matches('.slcsb-item');
      });
      collapse(list, items);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* SL_GALLERY_CTRL_20260924 is op 2026-10-01 VERWIJDERD.
   Dat deel deelde foto's in per KLEUR (niet per exacte variant), verplaatste foto's in de DOM
   (moveFirst) en stuurde Flickity tegelijk met stonea-variant-media-v2.js aan via herhaalde
   setTimeouts. Dat gaf de flicker, verkeerde Flickity-posities en twee .is-selected foto's.
   De enige regeling voor variantfoto's is nu assets/stonea-variant-media-v2.js (window.SLVariantMedia). */


/* SL_THUMB_SYNC_20260924: de paarse rand bij de kleine foto's volgt altijd de grote foto,
   ook als je op de grote foto swipet of de pijlen gebruikt (telefoon én desktop).
   De gekozen kleine foto wordt binnen de kolom/rij in beeld geschoven.
   2026-10-01: de gekozen foto komt nu rechtstreeks van Flickity (selectedElement),
   niet meer van de eerste .is-selected in de DOM. */
(function () {
  if (window.SL_THUMB_SYNC) return;
  window.SL_THUMB_SYNC = true;
  var pending = false;

  function selectedSlide(slider) {
    var fl = slider.flkty;
    if (fl && fl.selectedElement) return fl.selectedElement;
    return slider.querySelector('.flickity-slider > .product-images__slide.is-selected');
  }

  function sync() {
    pending = false;
    var slider = document.getElementById('Product-Slider');
    var thumbs = document.getElementById('Product-Thumbnails');
    if (!slider || !thumbs) return;
    var sel = selectedSlide(slider);
    if (!sel) return;
    var m = (sel.id || '').match(/-(\d+)$/);
    if (!m) return;
    var t = thumbs.querySelector('.product-thumbnail[id$="-' + m[1] + '"]');
    if (!t) return;
    if (!t.classList.contains('sl-thumb-active')) {
      thumbs.querySelectorAll('.product-thumbnail.sl-thumb-active').forEach(function (el) { el.classList.remove('sl-thumb-active'); });
      t.classList.add('sl-thumb-active');
    }
    /* in beeld schuiven binnen de kolom (telefoon) of rij (desktop), zonder de pagina te laten verspringen */
    var tr = t.getBoundingClientRect();
    var cr = thumbs.getBoundingClientRect();
    if (tr.height && cr.height) {
      if (tr.top < cr.top) thumbs.scrollTop += tr.top - cr.top;
      else if (tr.bottom > cr.bottom) thumbs.scrollTop += tr.bottom - cr.bottom;
      if (tr.left < cr.left) thumbs.scrollLeft += tr.left - cr.left;
      else if (tr.right > cr.right) thumbs.scrollLeft += tr.right - cr.right;
    }
  }
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(sync);
  }
  function start() {
    var slider = document.getElementById('Product-Slider');
    if (!slider || slider.dataset.slThumbSync) return;
    slider.dataset.slThumbSync = '1';
    new MutationObserver(queue).observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
})();